import React from 'react';

interface FormRadioGroupProps {
  label: string;
  required?: boolean;
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  name?: string;
}

const FormRadioGroup: React.FC<FormRadioGroupProps> = ({
  label,
  required = false,
  options,
  value,
  onChange,
  error,
  name,
}) => {
  const radioName = name || `radio-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
      }}
    >
      {/* Label */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          position: 'relative',
        }}
      >
        <label
          style={{
            fontSize: '14px',
            fontWeight: 500,
            color: 'var(--label-color-default)',
            lineHeight: '20px',
          }}
        >
          {label}
        </label>
        {required && (
          <span
            style={{
              color: '#dc2626',
              fontSize: '10px',
              position: 'absolute',
              left: '-8px',
              top: '2px',
              fontWeight: 600,
            }}
          >
            *
          </span>
        )}
      </div>

      {/* Radio Group */}
      <div
        style={{
          display: 'flex',
          gap: '24px',
          alignItems: 'center',
          paddingLeft: '4px',
        }}
      >
        {options.map(option => {
          const isSelected = value === option.value;

          return (
            <label
              key={option.value}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 400,
                color: 'var(--text-input-default)',
                position: 'relative',
              }}
            >
              <input
                type="radio"
                name={radioName}
                value={option.value}
                checked={isSelected}
                onChange={() => onChange(option.value)}
                style={{
                  appearance: 'none',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  border: '2px solid #ffffff',
                  backgroundColor: isSelected ? '#ffffff' : 'transparent',
                  cursor: 'pointer',
                  position: 'relative',
                  flexShrink: 0,
                  margin: 0,
                }}
                onFocus={e => {
                  e.currentTarget.style.outline = '2px solid var(--accent-primary)';
                  e.currentTarget.style.outlineOffset = '2px';
                }}
                onBlur={e => {
                  e.currentTarget.style.outline = 'none';
                }}
              />
              {isSelected && (
                <div
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#0f172a',
                    position: 'absolute',
                    left: '4px',
                    pointerEvents: 'none',
                  }}
                />
              )}
              <span>{option.label}</span>
            </label>
          );
        })}
      </div>

      {/* Error Message */}
      {error && (
        <span
          style={{
            fontSize: '12px',
            color: '#dc2626',
            marginTop: '4px',
          }}
        >
          {error}
        </span>
      )}
    </div>
  );
};

export default FormRadioGroup;
